import { compile, type PathFunction } from 'path-to-regexp';

import type { Parameters } from '@navigation/routes.types';

const cache: Record<
  string,
  PathFunction<Partial<Record<string, string | string[]>>>
> = {};
const cacheLimit = 10_000;
let cacheCount = 0;

const compilePath = (path: string) => {
  if (cache[path]) return cache[path];

  const generator = compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount += 1;
  }

  return generator;
};

export const makeDynamicApiRoute = (
  path: string,
  parameters: Parameters,
): string => {
  const generator = compilePath(path);
  return path === '/' ? path : generator(parameters);
};
